__turbopack_context__.v({
  "all": "names-page-module__IQ1j8W__all",
  "allTitle": "names-page-module__IQ1j8W__allTitle",
  "chips": "names-page-module__IQ1j8W__chips",
  "generator": "names-page-module__IQ1j8W__generator",
  "grid": "names-page-module__IQ1j8W__grid",
  "groupItems": "names-page-module__IQ1j8W__groupItems",
  "groupTitle": "names-page-module__IQ1j8W__groupTitle",
  "lead": "names-page-module__IQ1j8W__lead",
  "options": "names-page-module__IQ1j8W__options",
  "page": "names-page-module__IQ1j8W__page",
  "result": "names-page-module__IQ1j8W__result",
  "resultCopied": "names-page-module__IQ1j8W__resultCopied",
  "resultFamily": "names-page-module__IQ1j8W__resultFamily",
  "resultName": "names-page-module__IQ1j8W__resultName",
  "resultNickname": "names-page-module__IQ1j8W__resultNickname",
  "resultNote": "names-page-module__IQ1j8W__resultNote",
  "results": "names-page-module__IQ1j8W__results",
  "species": "names-page-module__IQ1j8W__species",
  "title": "names-page-module__IQ1j8W__title",
});
